import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import {
  AgeGroupService, ArrayService, AuthService, ChurchService, DatabaseService, 
  ServiceYearMemberService, FestivalUserService, MemberService 
} from 'src/core/services';
import { DocumentReference, ServiceYearMember, SportTeam } from '../../core/models';
import { ModalController, NavController, AlertController, LoadingController } from '@ionic/angular';
import { PageClass } from 'src/core/classes/page';

import { NgForm } from '@angular/forms';
import { TextService } from 'src/core/services/text-service';

@Component({
  selector: 'app-import-members',
  templateUrl: './import-members.component.html',
  styleUrls: ['./import-members.component.less', '../../core/styles/common.less']
})

export class ImportMembersComponent extends PageClass implements OnInit {

  membersGroupList: ServiceYearMember[];
  memberGroup: ServiceYearMember;
  sportTeamList: SportTeam[];
  membersToImport: any = '';

  yearLevelList: DocumentReference[];

  filter: any = { filterAgeGroup: undefined, filterChurch: undefined };
  isLoading = true;

  @ViewChild('membersForm', null) membersForm: NgForm;
  @ViewChild('closeModal', null)  closeModal: ElementRef;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private serviceYearMemberService: ServiceYearMemberService,
    protected festivalUserService: FestivalUserService,

    protected navController: NavController,
    protected modalController: ModalController,
    protected alertController: AlertController,
    protected loadingController: LoadingController,

    private memberService: MemberService,

    private textService: TextService
  ) {
      super(
      ageGroupService, arrayService, authService, 
      churchService, databaseService, festivalUserService
    );
  }

  protected loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      this.currentUser.ageGroupList.sort(this.arrayService.orderByDisplayName);

      this.filter.filterChurch = localStorage.getItem('filteredChurch') ? 
        this.churchList.find(c => c.reference.id == localStorage.getItem('filteredChurch')) : 
        this.churchList[0];

      this.getMemberGroupList();
    }
  }

  public getMemberGroupList() {
    // Save Filters
    localStorage.setItem('filteredChurch', this.filter.filterChurch.reference.id);
    this.filter.filterAgeGroup = { 
      displayName: 'All Age Groups' 
    };

    this.membersGroupList = [];
    this.serviceYearMemberService.getMembersGroups(this.filter.filterChurch, this.filter.filterAgeGroup).subscribe(membersGroupList => {
        this.membersGroupList = membersGroupList.sort(this.serviceYearMemberService.orderByMemberName);

        this.getYearLevelList();
      });
  }

  public getYearLevelList() {
    this.ageGroupService.getYearLevels().subscribe((yearLevels) => {
      this.yearLevelList = [];
      yearLevels.map(a => this.yearLevelList.push({
        displayName: a.displayName, 
        reference: this.databaseService.doc(`ageGroups/${a.id}`).ref
      }));

      this.isLoading = false;
    })
  }

  public async importMembers() {

    const memberRows = (document.getElementById("membersToImport") as any).value;

    let members = memberRows.toString().split('\n');

    members.forEach(line => {
      let memberDetails = line.toString().split(',');

      this.importMember(memberDetails);
    }); 
  }

  public importMember(memberDetails: string) {

    let genderList = this.memberService.getGenderList();
    let ageGroupList = this.currentUser.ageGroupList;
    let yearLevelList = this.yearLevelList;
    

    let church = this.filter.filterChurch;
    let currentUser = this.currentUser.user;
    let memberService = this.memberService;
    let serviceYearMemberService = this.serviceYearMemberService;

    let firstName = this.textService.toPascalCase(memberDetails[0]);
    let lastName = this.textService.toPascalCase(memberDetails[1]);
    let ageGroup = memberDetails[2].trim();
    let yearLevel = memberDetails[3].trim();
    let gender = memberDetails[4].trim();
    let dob = memberDetails[5].trim();

    console.log(`${firstName} - ${lastName} - ${ageGroup} - ${yearLevel} - ${gender} - ${dob}`);

    let importedMember: any = {
      church: church,
      dateOfBirth: dob,
      firstName: firstName,
      lastName: lastName,
      gender: genderList.find(gl => gl.name == gender),
      isActive : true,
      isDeleted : false,
      createdBy : currentUser,
      createdAt : new Date().getTime(),
      updatedBy : currentUser,
      updatedAt : new Date().getTime()
    };

    let importedAgeGroup = ageGroupList.find(ag => ag.displayName == ageGroup);
    let importedYearLevel = yearLevelList.find(yl => yl.displayName == yearLevel);

    let importedMemberGroup: any = {
      ageGroup: importedAgeGroup,
      yearLevel: importedYearLevel,
      notes : 'Imported',
      isActive : true,
      isDeleted : false,
      choir : false,
      drama : false,
      it : false,
      media : false,
      visualArt : false,
      church : importedMember.church,
      gender : importedMember.gender,
      createdBy : currentUser,
      createdAt : new Date().getTime(),
      updatedBy : currentUser,
      updatedAt : new Date().getTime()
    };

    memberService.createMember(importedMember)
      .then(
        (memberId) => {
          importedMember.id = memberId;

          serviceYearMemberService.createMemberGroup(importedMemberGroup, importedMember);
          console.log(`imported ${importedMember.firstName} ${importedMember.lastName}`);
        });
  }

}
